<template>
    <div v-on-clickaway="close" class="dropdown relative">
        <slot :toggle="toggle" />

        <transition name="fade">
            <slot v-if="visible" name="menu" :toggle="toggle" />
        </transition>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
    mixins: [clickaway],

    data: () => ({ visible: false }),

    methods: {
        toggle() {
            this.visible = !this.visible
        },

        close() {
            this.visible = false
        },
    },
}
</script>

<style>
    .dropdown {
    }

    .dropdown ul li {
        transition: all 0.2s ease-in-out;
    }

    .dropdown ul li:hover {
        @apply .bg-grey-lightest;
    }

    .dropdown ul li a {
        @apply .block .p-4 .no-underline;

        transition: all 0.2s ease-in-out;
    }

    .dropdown-menu-left {
      top: 3rem;
      left: -1.75rem;
    }

    .dropdown-arrow-left {
      top: calc(-1.35rem);
      left: 2.3rem;
    }

    .dropdown-menu-right {
      top: 3.25rem;
      right: -1.5rem;
    }

    .dropdown-arrow-right {
      top: calc(-1.35rem);
      right: 1.75rem;
    }

    .dropdown-alt .dropdown-trigger {
      @apply .flex .items-center .h-8 .px-3 .rounded;
    }

    .dropdown-trigger-active .dropdown-trigger {

    }
</style>



// WEBPACK FOOTER //
// src/components/Dropdown.vue